<template>
	<v-card rounded color="transparent">
		<v-list class="opaqueBg">
			<v-list-item>
				<v-list-item-content>
					<v-text-field
						outlined
						prepend-inner-icon="mdi-account-search"
						label="Search"
						hide-details
						clearable
						v-model="search"
					></v-text-field>
				</v-list-item-content>
			</v-list-item>
			<v-list-item-group>
				<UserItem
					@click="$emit('view', user)"
					v-for="user in filteredUsers"
					:key="user.Username"
					v-bind="user"
				/>
			</v-list-item-group>
		</v-list>
	</v-card>
</template>

<script>
import UserItem from './n-items/UserItem'
export default {
	name: 'UserList',
	components: {
		UserItem,
	},

	props: {
		users: Array,
	},

	data() {
		return {
			search: '',
		}
	},

	computed: {
		filteredUsers() {
			if (!this.search) return this.users

			const search = this.search.toLowerCase().trim()

			return this.users.filter(({ Username, Attributes }) => {
				const Name = Attributes.name || ''
				return (
					Username.toLowerCase().indexOf(search) > -1 ||
					Name.toLowerCase().indexOf(search) > -1
				)
			})
		},
	},
}
</script>
